import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { TruvBridgeInline } from '@truv/react';
import { postMessage, VoxSource, VoxEventType } from '../events';

export const TruvEmbed = (): JSX.Element => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const [isOpened, setOpened] = useState(false);

  // Decode and parse token
  let parsedToken: any;
  let accessToken: string | undefined;
  try {
    parsedToken = JSON.parse(atob(token));
    accessToken = parsedToken?.bridgeToken || parsedToken?.accessToken || '';
  } catch (e) {
    console.error('Error decoding token:', e);
    postMessage({ eventType: VoxEventType.ERROR, payload: { error: e }, _metadata: { source: VoxSource.TRUV, eventType: 'onError' } });
  }

  // Auto-open when bridgeToken is provided
  useEffect(() => {
    if (accessToken) {
      setOpened(true);
    }
  }, [accessToken]);

  if (!accessToken) {
    postMessage({ eventType: VoxEventType.ERROR, payload: { error: 'Invalid token' }, _metadata: { source: VoxSource.TRUV, eventType: 'onError' } });
  }

  return (
    <>
      <TruvBridgeInline
        isOpened={isOpened}
        style={{ width: '100%', height: '100vh' }}
        bridgeParams={{
          bridgeToken: accessToken,
          ...parsedToken,
          onLoad: () => {
            postMessage({ eventType: VoxEventType.LOAD, payload: null, _metadata: { source: VoxSource.TRUV, eventType: 'onLoad' } });
          },
          onSuccess: (publicToken: string, metaData: any) => {
            postMessage({ eventType: VoxEventType.COMPLETE, payload: { publicToken, metaData }, _metadata: { source: VoxSource.TRUV, eventType: 'onSuccess' } });
          },
          onEvent: (eventType: string, payload?: any) => {
            if (eventType === 'EMPLOYER_SELECTED') return postMessage({ eventType: VoxEventType.EMPLOYER_SELECTED, payload, _metadata: { source: VoxSource.TRUV, eventType: `onEvent(${eventType})` } });
            if (eventType === 'UNSUPPORTED_BROWSER') return postMessage({ eventType: VoxEventType.ERROR, payload, _metadata: { source: VoxSource.TRUV, eventType: `onEvent(${eventType})` } });
            postMessage({ eventType: VoxEventType.UNDEFINED, payload, _metadata: { source: VoxSource.TRUV, eventType: `onEvent(${eventType})` } });
          },
          onClose: () => {
            setOpened(false);
            postMessage({ eventType: VoxEventType.COMPLETE, payload: null, _metadata: { source: VoxSource.TRUV, eventType: 'onClose' } });
          },
        }}
      />
    </>
  );
};
